import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { Subject, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WalletByTransaction } from '../models/walletByTransaction';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionReportingService {


  transactionSubject = new Subject<any[]>();
  constructor(private http: HttpClient,
    private configService: ConfigurationService,
    private notifService: NotifMessageService,
    private utilsService : UtilsService) { }

  saveSubject = new Subject<any[]>();

  getNumberOfPaymentMeansByPeriod(criteria, url): Observable<any> {
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<WalletByTransaction>(this.configService.config.urlAPI.urlTransactionsReports + url, { params: criteria }).pipe(catchError(err => {
      console.log("error getNumberOfPaymentMeansByPeriod", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
      return of(null);
    }));
  }

  getNumberOfTxBySupplier(criteria): Observable<any> {
    let subUrl: string = "/txCount/bySupplier";
    this.utilsService.updateCriteriaWindow(criteria);


    return this.http.get<WalletByTransaction>(this.configService.config.urlAPI.urlTransactionsReports + subUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error getNumberOfTxBySupplier", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
      return of(null);
    }));
  }

  getNumberOfTxByPos(criteria): Observable<any> {
    let subUrl: string = "/topPos/byTxCount";
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<WalletByTransaction>(this.configService.config.urlAPI.urlTransactionsReports + subUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error getNumberOfTxByPos", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
      return of(null);
    }));
  }

  getTxCountByMerchant(criteria): Observable<any> {
    let subUrl: string = "/txCount/byMerchant";
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<WalletByTransaction>(this.configService.config.urlAPI.urlTransactionsReports + subUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error get ransaction count by merchant", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
      return of(null);
    }));
  }

  getTxCountByMerchantAndPoS(criteria): Observable<any> {
    let subUrl: string = "/txCount/byPosAndMerchant";
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<Array<WalletByTransaction>>(this.configService.config.urlAPI.urlTransactionsReports + subUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error get transaction count by merchant & PoS", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
      return of(null);
    }));

  }

  getTxEvolution(criteria): Observable<any> {
    let subUrl: string = "/txEvolution";
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<WalletByTransaction>(this.configService.config.urlAPI.urlTransactionsReports + subUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error get ransaction count by merchant", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_TRANSACTION_API', err);
      return of(null);
    }));
  }


  getCompletedPaymentTransactionsCountByMerchant(criteria): Observable<any> {
    let subUrl: string = "/completedTxCount/byMerchant";
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<WalletByTransaction>(this.configService.config.urlAPI.urlPaymentTransactionsReports + subUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error getCompletedPaymentTransactionsCountByMerchant", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_PAYMENT_TRANSACTION_API', err);
      return of(null);
    }));
  }


  getActiveUsersCountByMerchant(criteria): Observable<any> {
    let subUrl: string = "/usersCount/byMerchant";
    this.utilsService.updateCriteriaWindow(criteria);

    return this.http.get<WalletByTransaction>(this.configService.config.urlAPI.urlPaymentTransactionsReports + subUrl, { params: criteria }).pipe(catchError(err => {
      console.log("error getActiveUsersCountByMerchant", err);
      this.notifService.notifyErrorWithDetailFromApi('ERROR_PAYMENT_TRANSACTION_API', err);
      return of(null);
    }));
  }

  
}
